import { NodeViewContent } from '@tiptap/react';
import { FC } from 'react';
import { CustomGroupSectionComponentProps } from '../types';

export const CustomGroupSectionGenerated: FC<
  CustomGroupSectionComponentProps
> = () => {
  return <NodeViewContent className="custom-group-section-generated" />;
};
